export default {
  // Response Status
  SUCCESS: 'success',
  ERROR: 'fail',

  // Error code
  UNAUTHORIZED_CODE: 403,
  INVALID_TOKEN: 401,
  INVALID_ROLE: 409,

  // LocalStorage
  JWT: 'jwt',
  IS_LOGGED: 'isLoggedIn',
}
